




































































































































































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import Loading from "../general/Loading.vue";

import ModulesJson from "../../shared/ModulesJson";
import UserJson, { defaultUserJson } from "../../shared/UserJson";

import SettingsUserDetails from "./SettingsUserDetails.vue";
import { UserPermissionRank, UserPermissionRankNames } from "../../shared/UserPermissionRank";
import { UserPermissionType, UserPermissionTypeNames } from "../../shared/UserPermissionType";

export default Vue.extend({
  name: "SettingsMydata",
  components: {
    Loading,
    SettingsUserDetails,
  },
  props: {
    restClient: RestClient,
    loginUser: Object as Object as PropType<UserJson>,
    loginId: Number,
    loginPermission: Number,
    allActiveModules: Array as PropType<ModulesJson[]>,
  },
  data() {
    return {
      showUserDetails: false,
      detailsMode: "show",
      userDetails: null as UserJson | null,
      selectedUser: null as UserJson | null,
      UserPermissionRank: UserPermissionRank,
      UserPermissionRankNames: UserPermissionRankNames,
      UserPermissionType: UserPermissionType,
      UserPermissionTypeNames: UserPermissionTypeNames,
      newUserPassword: "",
    };
  },
  created() {
    this.$emit("resetAppFrameButtons");
    this.loadData();
  },
  methods: {
    toggleUserDetails: function () {
      this.showUserDetails = !this.showUserDetails;
      if (this.showUserDetails == false) {
        this.loadData();
      }
    },

    async loadData() {
      this.userDetails = null;
      if (this.restClient != null) {
        try {
          this.userDetails = await this.restClient.getUser(this.loginId);
        } catch (e) {
          alert(e.message);
        }
      }
    },

    openUserDetails(item: UserJson, mode: string) {
      if (item != null) {
        this.selectedUser = JSON.parse(JSON.stringify(item));
      } else {
        this.selectedUser = { ...defaultUserJson() };
      }

      this.detailsMode = mode;
      this.toggleUserDetails();
    },

    changeLoginData(loginName: string | null, loginPermission: number | null, loginPassword: string | null) {
      this.$emit("change-login-data", loginName, loginPermission, loginPassword);
    },
  },
  watch: {},
  computed: {},
});
